import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, matrix3x2Like, size2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            transform: matrix3x2Like,
            addressMode: AddressMode.optional().default("clamp"),
            resultSize: size2Like.optional(), // optional, if not provided, the result size will be computed from the source image and transform to fit the transformed image
            options: z
                .object({
                    compensateOffset: z.boolean().optional().default(false), // if true, the offset of the transform will be compensated to fit the transformed image into the result size
                })
                .default({}),
        }),
    },
}
